import { BASE_SITE_CONTEXT_ID, SiteContextConfig, getContextParameterDefault } from '@spartacus/core';

export function baseSiteConfigValidator(config: SiteContextConfig) {
  if (getContextParameterDefault(config, BASE_SITE_CONTEXT_ID) === undefined) {
    return 'Please configure context.parameters.baseSite before using storefront library!';
  }
}
